import { Clock, User, FileText, Shield } from 'lucide-react';

const MILESTONE_LABELS = {
  'REGISTERED': 'Cadastro Realizado',
  'DOCUMENT_UPLOADED': 'Documento Enviado',
  'DOCUMENT_APPROVED': 'Documento Aprovado',
  'TERM_SIGNED': 'Termo Assinado',
  'PROTOCOL_SENT': 'Protocolo Enviado',
  'ACTION_FILED': 'Acao Ajuizada',
  'NEG_SPC_CLEARED': 'Baixa SPC Brasil',
  'NEG_BOA_VISTA_CLEARED': 'Baixa Boa Vista',
  'NEG_CENPROT_CLEARED': 'Baixa Cenprot',
  'NEG_SERASA_CLEARED': 'Baixa Serasa',
};

const SOURCE_LABELS = {
  'system': 'Sistema',
  'admin': 'Administrador',
  'association': 'Associacao',
};

export default function MilestoneHistory({ milestones = [] }) {
  if (milestones.length === 0) {
    return (
      <div className="text-center py-6" data-testid="empty-state">
        <Clock size={32} className="mx-auto text-white/20 mb-2" />
        <p className="text-sm text-white/40">Nenhum marco registrado.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid="milestone-history">
      {milestones.map((ms, index) => (
        <div
          key={ms.id || index}
          className="flex gap-3 p-4 rounded-xl bg-white/[0.03] border border-white/10 hover:border-white/15 transition-colors"
        >
          {/* Timeline dot and line */}
          <div className="flex flex-col items-center">
            <div className="w-3 h-3 rounded-full bg-[var(--rn-green)] mt-1" />
            {index < milestones.length - 1 && (
              <div className="w-0.5 flex-1 bg-white/10 mt-1" />
            )}
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-2">
              <h4 className="text-sm font-medium text-white/90">
                {MILESTONE_LABELS[ms.type] || ms.type}
              </h4>
              <span className="text-xs text-white/40 whitespace-nowrap">
                {new Date(ms.occurredAt).toLocaleDateString('pt-BR', {
                  day: '2-digit', month: '2-digit', year: 'numeric',
                  hour: '2-digit', minute: '2-digit'
                })}
              </span>
            </div>

            {/* Details */}
            <div className="flex flex-wrap items-center gap-3 mt-2">
              <div className="flex items-center gap-1 text-xs text-white/50">
                <Shield size={12} />
                <span>Fonte: {SOURCE_LABELS[ms.source] || ms.source}</span>
              </div>

              {ms.exportList && (
                <div className="flex items-center gap-1 text-xs text-white/50">
                  <FileText size={12} />
                  <span>Lista: {ms.exportList.name}</span>
                </div>
              )}

              {ms.payload && Object.keys(ms.payload).length > 0 && (
                <div className="text-xs text-white/40">
                  {Object.entries(ms.payload).map(([key, val]) => (
                    <span key={key} className="mr-2">{key}: {String(val)}</span>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
